import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import CurrencyFormat from "react-currency-format";
import Styles from './styles.module.sass';

import { decodeStorage, encodeStorage, removeStorage } from 'newFunctions/storageBase64'
import { ModalError } from 'newComponents/Error/ErrorModal'
import { useIsMobile } from 'newHooks/useIsMobile'
import Loading from 'newComponents/Loading'
import { Error500 } from 'newComponents/Error/Error500'
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'


import { usePlanesPago } from 'newHooks/usePlanesPago'
import ContentSinglePlans from 'newFunctions/Pagos/ContentSinglePlans';
import ContentMultiplePlans from 'newFunctions/Pagos/ContentMultiplePlans';
import CardEndingPayPlan from 'newFunctions/Pagos/CardEndingPayPlan';
import MainLayout from 'newComponents/Layout/MainLayout';
import CreditoLayout from 'newComponents/Layout/CreaditoLayout';
import SectionLayout from 'newComponents/Layout/SectionLayout';


const PagarTarjeta = () => {
    const [ data, setData ] = useState()

    const { 
        singlePlanData,
        completePlanData,
        showModal,
        errorCode,
        setErrorCode,
        handleClose
    } = usePlanesPago()

    let noInternetPayment

    //- Codigo de instana para track de pagina 
    useEffect(()=>{
        // window.ineum('page', 'Card Payment Credit-Page')
        // window.ineum('meta', 'portal', 'Credito')
    },[])

    const history = useHistory()
    const { isMobile } = useIsMobile()
    const [ loading, setLoading ] = useState(false)

    const pagoExpress = decodeStorage('pagoExpress')
    const lastConsultData = decodeStorage('lastConsultData')
    let dataAcount = {}
    if(pagoExpress){
        dataAcount = {
            account_number: pagoExpress?.account_number,
            cardending: pagoExpress?.cardending,
            card: pagoExpress?.card
        } 
        noInternetPayment = pagoExpress?.no_internet
    }else{
        dataAcount = {
            account_number: lastConsultData[0]?.account_number,
            cardending: lastConsultData[0]?.cards[0]?.cardending,
            card: lastConsultData[0]?.cards[0]?.card_number
        }
        noInternetPayment = decodeStorage('sears_numero_internet')
    }

    const [ showMultiplan, setShowMultiplan ] = useState(false)
    const [ ifSelectedMultiplan, setifSelectedMultiplan ] = useState(false)
    const [ selectMorePlans, setSelectMorePlans ] = useState(false)
    const [ textPlan, setTextPlan ] = useState()
    const [ totalPlansPay, setTotalPlansPay ] = useState(0)
    const [ totalArrayPlan, setTotalArrayPlan ] = useState([])

    // remueve el plan actual
    useEffect(()=>{
        removeStorage('payCardRelation')
        removeStorage('payCodeSuccess')

    },[])

    // funcion para pagar plan simple
    const paySimplePlan = () =>{
        let valorPlan = document.querySelector('.contentCardsSimplePlan input[type="radio"]:checked').value
        let valorTerminal = document.querySelector('.contentCardsSimplePlan input[type="radio"]:checked').dataset.terminal
        if(valorPlan >= 1){
            payPlans(valorPlan, "single", '', valorTerminal)
        }else{
            setErrorCode({"codMen":'ER0PAY0'})
        }
    }

    // funcion para pagar multi plan
    const payMultiplePlan = () =>{
        let valorPlan = Number( document.querySelector('.contButton .contentStrong span').innerText.replace('$', '').replace(/,/ig, '') )
        if( valorPlan >= 1){
            payPlans(valorPlan, "multi", totalArrayPlan, 15 )
        }else{
            setErrorCode({"codMen":'ER0PAY0'})
        }
    }

    // funcion generar bloque de pago
    const payPlans = (valorPlan, tipoPlan, arrayPlan, terminal) =>{
        let totalToPay = Number(valorPlan)
        let planPagoGral = []

        if(tipoPlan === "single"){
            planPagoGral.push({
                plan: 0,
                sequence: 0,
                amount: totalToPay
            })
        }else if(tipoPlan === "multi"){
            planPagoGral = arrayPlan
        }

        let payCardRelation = {
            'totalToPay' : totalToPay,
            'planPagoGral': planPagoGral,
            'dataAcount': dataAcount,
            'terminal': terminal,
            'searsInternet': noInternetPayment 
        }
        encodeStorage('payCardRelation', payCardRelation)
        history.push(`${BASE_PATH}${SUB_DIRECTORY}elegir-tarjeta`)
    }

    // Cambia de simplePlay a multiPlan
    const changeMultiplan = () => setShowMultiplan(true)
    const returnSinglePayment = () => setShowMultiplan(false)
    
    const deselectMorePlans = () => {
        setifSelectedMultiplan(false)
        setSelectMorePlans(false)
        // console.log('deselectMorePlans ')
    }
    
    const clickMorePlans = () => {
        if(document.querySelector('.cardMultiPlansSelected input[name="multiPlanSelected"]')){
            document.querySelector('.cardMultiPlansSelected input[name="multiPlanSelected"]').checked = true
            // console.log('clickMorePlans ')
            changeRadiosMultiplan()
        }
    }
    
    const changeRadiosMultiplan = () => {
        setifSelectedMultiplan(true)
        setSelectMorePlans(true)
        // console.log('changeRadiosMultiplan ')
        const radiosPlans =  document.querySelectorAll('.contentCardsSimplePlan input[type="radio"]')
        radiosPlans.forEach(radio => {
            radio.checked = false
        })
    }

    useEffect(()=>{
        if(completePlanData){
            setTimeout(() => {
                clickMorePlans()
            }, 700)
        }
    },[completePlanData])


    return (
        <MainLayout>
            <CreditoLayout setData={setData} >
                 { loading && <Loading /> }
                    {errorCode >= 500
                        ? <Error500 />
                        :
                            <>
                                {!showMultiplan 
                                    ?
                                        <SectionLayout title="PAGAR TARJETA">
                                            <div className="contPlanes">
                                                <div>
                                                    <h2 className={Styles?.h2}>Selecciona un importe</h2>
                                                    {completePlanData?.length > 1 &&
                                                        <div 
                                                            className={`${Styles?.cardMultiPlansSelected} cardMultiPlansSelected`}
                                                            onClick={changeRadiosMultiplan}>
                                                            <input 
                                                                type="radio" 
                                                                id="typeCardView" 
                                                                name="multiPlanSelected" 
                                                                value={singlePlanData.minimum_to_pay} 
                                                                data-terminal="0" 
                                                            />
                                                            <label for="typeCardView">
                                                                <div 
                                                                    className={Styles?.typeCardView}
                                                                >Pagar planes en especifico</div>
                                                            </label>
                                                        </div>
                                                    }
                                                    <ContentSinglePlans 
                                                        singlePlanData={singlePlanData}
                                                        deselectMorePlans={deselectMorePlans}
                                                        selectMorePlans={selectMorePlans}
                                                    />
                                                </div>
                                            </div>
                                        </SectionLayout>
                                    :
                                        <SectionLayout title="PAGAR TARJETA">
                                            <div className="contPlanes">
                                                <div>
                                                    <h2 className={Styles?.h2}>Selecciona planes de pago específicos</h2>
                                                    <ContentMultiplePlans 
                                                        completePlanData={completePlanData} 
                                                        setTextPlan={setTextPlan} 
                                                        setTotalPlansPay={setTotalPlansPay}
                                                        setTotalArrayPlan={setTotalArrayPlan}
                                                    />
                                                </div>
                                            </div>
                                        </SectionLayout>
                                }  
                                
                                <div className={isMobile === 'desktop' ? "contButton"  : "contButton mobile"}>
                                    {!showMultiplan 
                                        ? 
                                            ifSelectedMultiplan
                                                ? <button className={Styles?.btnRojo} onClick={changeMultiplan}>Siguiente</button>
                                                : <button className={Styles?.btnRojo} onClick={paySimplePlan}>Siguiente</button>
                                        :
                                            <>
                                                <div className={Styles?.contResumeData}>
                                                    <p className={Styles?.h3}>VAS A PAGAR</p>
                                                    <div className={`${Styles?.contentStrong} contentStrong`}>
                                                        <p>Cantidad a pagar</p>
                                                        <CurrencyFormat
                                                            value={Number(totalPlansPay % 1) === 0 ? totalPlansPay + '.001' : totalPlansPay}
                                                            displayType={'text'}
                                                            decimalScale={2}
                                                            FixedDecimalScale={true}
                                                            thousandSeparator={true} prefix={'$'} renderText={value => <span>{value} </span>}
                                                        />
                                                    </div>
                                                    
                                                    <CardEndingPayPlan
                                                        singlePlanData={singlePlanData}
                                                        completePlanData={completePlanData}
                                                    />
                                                </div>
                                                <div className={Styles?.contCardsButtons}>
                                                    <button className={Styles?.btnBlanco} onClick={returnSinglePayment} >Regresar</button>
                                                    <button className={Styles?.btnRojo} onClick={payMultiplePlan} >Siguiente</button>
                                                </div>
                                            </>
                                    }
                                </div>
                            </>
                    }

                    {showModal &&
                        <ModalError errorCode={errorCode} handleClose={handleClose} />
                    }
            </CreditoLayout>
        </MainLayout>
    )
}

export default PagarTarjeta